import { signOut } from "next-auth/react";
import { env } from "next-runtime-env";
import useTNStore from "@/stores/TNStore";
import useUBStore from "@/stores/UBStore";
import useVFCCSessionStore from "@/stores/VFCCSessionStore";

export const performSignOut = async (provider?: string) => {
    await signOut({ callbackUrl: "/" });

    useVFCCSessionStore.getState().clearVFCCSession();
    useTNStore.getState().clearTN();
    useUBStore.getState().clearUbid();

    const convertedProvider = (provider ?? "").toLowerCase();

    if (convertedProvider === "b") {
        const environment = env("NEXT_PUBLIC_AUTH_ENV") === "stage" ? "stage." : "";
        globalThis.location.assign(
            `https://bcontent.${environment}att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=${encodeURIComponent(globalThis.location.origin)}`,
        );
    } else {
        const finalProvider = convertedProvider || "e";
        globalThis.location.assign(
            `https://oidc.${env("NEXT_PUBLIC_AUTH_ENV")}.${finalProvider}login.att.com/pkmslogout?retURL=${encodeURIComponent(globalThis.location.origin)}`,
        );
    }
};
